// extracted by mini-css-extract-plugin
module.exports = {"card":"UserOrgCard_card__3QB6U","childrenWrapper":"UserOrgCard_childrenWrapper__13OlK","innerWrapper":"UserOrgCard_innerWrapper__1NHje"};